import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';
import Constants from 'root/constants';
import Modals from 'root/modals';
import Tooltip from 'root/module/tooltip';
import Form from 'root/module/form';
import View_Integrations from 'view/feedback_integrations';
import {changeFeedbacksDueDate, showAutoReplyMessage, deleteComment} from 'service/feedback';


export default View.extend({
    inbox_mode: false,

    views: {
        integrations: {}
    },

    events: {
        'click .unmerge-feedback'                        : 'onUnmergeFeedback',
        'click .open-primary-feedback'                   : 'onOpenPrimaryFeedback',
        'click .dropdown-feedback-type li'               : 'onSelectFeedbackType',
        'click .dropdown-feedback-approve li'            : 'onApproveFeedback',
        'click .dropdown-workflow li'                    : 'onSelectWorkflow',
        'click .workflow-dropdown-group > button.resolve': 'onResolveWorkflow',
        'click .dropdown-assignee li'                    : 'onSelectAssignee',
        'click .dropdown-priority li'                    : 'onSelectPriority',
        'click .dropdown-feedback-category li'           : 'onSelectFeedbackCategory',
        'click .manage-categories'                       : 'onManageCategories',
        'change input[name="feedback_due_date"]'         : 'onChangeDueDate',
        'click .pick-due-date'                           : 'onPickDueDate',
        'click .user-invite'                             : 'onInviteUser'
    },

    dom_handlers: {
        onUnmergeFeedback: function(e) {
            e.preventDefault();

            Modals.unmergeFeedback(this.model.id, () => {
                this.model.set('primary_feedback_id', 0);
            });
        },

        onOpenPrimaryFeedback: function(e) {
            e.preventDefault();
            Modals.openFeedbackSidebar(this.model.get('primary_feedback_id'));
        },

        onSelectFeedbackType: function(e) {
            var feedback_type = parseInt($(e.currentTarget).data('val'), 10);

            Cache.app.request({
                action: 'feedback/setFeedbackType',
                data: {
                    ids           : [this.model.id],
                    feedback_type : feedback_type
                }
            });

            this.model.set('feedback_type',feedback_type);
            UI.success('Feedback type changed to ' + this.model.getFeedbackTypeName());
        },

        onApproveFeedback: function(e) {
            var is_approved = $(e.currentTarget).data('val') == 1;

            if (is_approved === this.model.get('is_portal_approved')) {
                return;
            }

            Cache.app.request({
                action: 'feedback/approveForPortal',
                data: {
                    feedback_id: this.model.id
                }
            });

            if (is_approved) {
                this.model.set({
                    is_portal_approved: true,
                    feedback_type: Constants.FEEDBACK_FEATURE_REQUEST
                });

                UI.success('Feature approved');
            } else {
                this.model.set('is_portal_approved', is_approved);

                UI.success('Feature unapproved');
            }
        },

        onSelectWorkflow: function(e) {
            var workflow_id = parseInt($(e.currentTarget).data('id'), 10);
            const option_type = $(e.currentTarget).data('type');

            if (!workflow_id) {
                return;
            }

            if (workflow_id === this.model.get('workflow')) {
                return;
            }

            const is_resolved = Cache.workflow.get(workflow_id).isResolved();

            Cache.app.request({
                action: 'feedback/setWorkflow',
                data: {
                    ids      : [this.model.id],
                    workflow : workflow_id,
                    send_autoreply: is_resolved && option_type === 'resolve-reply'
                },
                success: (result) => {
                    if (!result || !result.autoreply_comments || result.autoreply_comments.length === 0) {
                        return;
                    }
                    const autoreply_comments = result.autoreply_comments;
                    const autoreply_comment_ids = autoreply_comments.map((comment) => comment.id);
                    showAutoReplyMessage(() => {
                        deleteComment(autoreply_comment_ids);
                    });

                    // Do something with the comments
                    autoreply_comments.forEach((autoreply_comment) => {
                        if (!Cache.feedback_comment.get(autoreply_comment.id)) {
                            Cache.feedback_comment.add(autoreply_comment);
                        }
                    });
                }
            });

            this.model.set('workflow', workflow_id);
            UI.success('Status updated');
        },

        onResolveWorkflow: function() {
            var project_id = this.model.get('project_id');
            var project_workflow = Cache.workflow.where({project_id: project_id});
            var workflow_id = project_workflow[project_workflow.length - 1].id;

            Cache.app.request({
                action: 'feedback/setWorkflow',
                data: {
                    ids      : [this.model.id],
                    workflow : workflow_id,
                    send_autoreply: false
                },
                success: (result) => {
                    if (!result || !result.autoreply_comments || result.autoreply_comments.length === 0) {
                        return;
                    }
                    const autoreply_comments = result.autoreply_comments;
                    const autoreply_comment_ids = autoreply_comments.map((comment) => comment.id);
                    showAutoReplyMessage(() => {
                        deleteComment(autoreply_comment_ids);
                    });

                    // Do something with the comments
                    autoreply_comments.forEach((autoreply_comment) => {
                        if (!Cache.feedback_comment.get(autoreply_comment.id)) {
                            Cache.feedback_comment.add(autoreply_comment);
                        }
                    });
                }
            });

            this.model.set('workflow', workflow_id);
            Tooltip.removeAll();
            UI.success('Feedback resolved');
        },

        onInviteUser: function(e) {
            Modals.inviteUser();
        },

        onSelectAssignee: function(e) {
            var user_id = parseInt($(e.currentTarget).data('id'), 10);

            if (isNaN(user_id)) {
                return;
            }

            if (user_id === this.model.get('user_id')) {
                return;
            }

            Cache.app.request({
                action: 'feedback/setUser',
                data: {
                    ids     : [this.model.id],
                    user_id : user_id
                }
            });

            this.model.set('user_id', user_id);
            UI.success('Feedback assigned');
        },

        onSelectPriority: function(e) {
            var priority = $(e.currentTarget).data('priority');

            if (!priority) {
                return;
            }

            if (priority === this.model.get('priority')) {
                return;
            }

            Cache.app.request({
                action: 'feedback/setPriority',
                data: {
                    ids      : [this.model.id],
                    priority : priority
                }
            });

            this.model.set({priority: priority});
            UI.success('Priority updated');
        },

        onSelectFeedbackCategory: function(e) {
            var category = $(e.currentTarget).text();

            var categories = [];
            if (this.model.get('category')) {
                categories = this.model.get('category').split(',');
            }

            var index = categories.indexOf(category);
            var action = '';

            if (index === -1) {
                categories.push(category);

                action = 'feedback/addCategory';
            } else {
                categories.splice(index, 1);

                action = 'feedback/deleteCategory';
            }

            Cache.app.request({
                action: action,
                data: {
                    feedback_ids  : [this.model.id],
                    category_name : category
                }
            });

            this.model.set('category', categories.join(','));
            UI.success(action === 'feedback/addCategory' ? 'Category added' : 'Category removed');
        },

        onManageCategories: function() {
            Modals.projectSettings(this.model.get('project_id'));
        },

        onChangeDueDate: function(e) {
            var due_date = this.$el.find('input[name="feedback_due_date"]').val();

            this.doChangeFeedbacksDueDate(due_date);
        },
        onPickDueDate: function(e) {
            var type = $(e.currentTarget).attr('data-type');

            if (type === 'tomorrow') {
                this.doChangeFeedbacksDueDate('tomorrow');
            } else if (type === 'next_monday') {
                this.doChangeFeedbacksDueDate('next_monday');
            } else if (type === 'clear') {
                this.doChangeFeedbacksDueDate('clear');
            } else {
                this.$el.find('input[name="feedback_due_date"]').get(0).showPicker();
            }
        }
    },

    doChangeFeedbacksDueDate: function(due_date) {
        // due_date is either 'tomorrow', 'next_monday', or a date string
        // do validation checks here
        if (!due_date && due_date !== 'tomorrow' && due_date !== 'next_monday' && due_date !== 'clear' && isNaN((new Date(due_date)).getTime())) {
            return;
        }

        changeFeedbacksDueDate([this.model.id], due_date, (response) => {
            if (response && response.length > 0) {
                this.model.set('due_date', response[0].due_date);

                if (due_date === 'clear') {
                    UI.success('Due date removed');
                } else {
                    UI.success('Due date updated');
                }

            }
        });
    },

    initialize: function(options) {
        this.inbox_mode = !!options.inbox_mode;

        this.listenTo(this.model, 'change:feedback_type',       this.render);
        this.listenTo(this.model, 'change:is_portal_approved',  this.render);
        this.listenTo(this.model, 'change:workflow',            this.render);
        this.listenTo(this.model, 'change:user_id',             this.render);
        this.listenTo(this.model, 'change:priority',            this.render);
        this.listenTo(this.model, 'change:category',            this.render);
        this.listenTo(this.model, 'change:primary_feedback_id', this.render);
        this.listenTo(this.model, 'change:due_date',            this.render);
    },

    render: function() {
        var portal = Cache.portal.findWhere({project_id: this.model.get('project_id')});
        var project_workflow = Cache.workflow.where({project_id: this.model.get('project_id')});

        // droption options
        var workflow_options = '';

        // Status(workflow)
        var selected_workflow = Cache.workflow.get(this.model.get('workflow')) ? Cache.workflow.get(this.model.get('workflow')) : '';
        var workflow_name     = selected_workflow ? selected_workflow.escape('name') : '';
        const is_resolved     = selected_workflow ? selected_workflow.isResolved() : false;

        const feedback_autoreply = Cache.feedback_autoreply.findWhere({project_id: this.model.get('project_id')});
        const is_autoreply_enabled = feedback_autoreply?.isEnabled(this.model.get('feedback_type'));

        const filtered_workflow = Cache.workflow.where({project_id: this.model.get('project_id')});
        filtered_workflow.forEach((workflow_model, index) => {
            var last = index === filtered_workflow.length - 1;
            var selected = selected_workflow?.id === workflow_model.id

            if (last) {
                workflow_options += '<li class="separator"></li>';
            }

            workflow_options +=
            '<li data-id="' + workflow_model.id + '" ' + (selected ? ' class="selected"' : '') + '>' +
                '<span class="workflow-option-colour" style="background-color:' + workflow_model.get('colour') + ';"></span>' +
                workflow_model.escape('name') +
            '</li>';

            if (last && !is_resolved && is_autoreply_enabled) {
                workflow_options += '<li class="separator"></li>';
                workflow_options +=
                '<li class="notrim" data-id="' + workflow_model.id + '" data-type="resolve-reply">' +
                    '<span class="workflow-option-colour" style="background-color:' + workflow_model.get('colour') + ';"></span>' +
                    workflow_model.escape('name') + ' & Auto-reply' +
                '</li>';
            }
        });

        // Assignee
        var assigned_user_id = this.model.get('user_id');
        var assigned_user = Cache.user.get(assigned_user_id);
        var assignees = Cache.app.getUsersByProject(this.model.get('project_id'), [Constants.ADMIN, Constants.ASSIGNEE]);

        // Category
        var selected_categories = this.model.get('category') ? this.model.get('category').split(',') : [];
        var categories = Cache.feedback_category.where({project_id: this.model.get('project_id')});

        var is_merged_feedback = this.model.isMergedFeedback();

        var is_overdue = this.model.isOverdue();
        var is_due_today = this.model.isDueToday();

        // set due date
        var due_date = this.model.get('due_date');
        var due_date_text = '';
        var due_date_tooltip = '';

        if (due_date) {
            if (is_overdue) {
                due_date_text = '<div class="text-danger"><i class="text-danger fa-regular fa-calendar-circle-exclamation"></i> ' + Util.moment(due_date, 'DD MMM YYYY', false, false) + '</div>';
                due_date_tooltip = 'Overdue';
            } else if (is_due_today) {
                due_date_text = '<div class="text-warning"><i class="text-warning fa-regular fa-calendar-circle-exclamation"></i> ' + Util.moment(due_date, 'DD MMM YYYY', false, false) + '</div>';
                due_date_tooltip = 'Due Today';
            } else {
                due_date_text = '<i class="fa-regular fa-calendar-clock text-icon"></i> ' + Util.moment(due_date, 'DD MMM YYYY', false, false);
            }
        }

        var resolve_title = 'Set to ' + (project_workflow.length ? project_workflow[project_workflow.length - 1].escape('name') : '');

        var due_date_options =
        (
            this.model.get('due_date') ?
            (
                '<li class="pick-due-date" data-type="clear">Clear due date</li>' +
                '<li class="separator"></li>'
            ) : ''
        ) +
        '<li class="pick-due-date" data-type="tomorrow">' +
            '<div class="flex-between">' +
                '<span>Tomorrow</span>' +
                '<span class="text-info margin-left-24">' + Util.getTomorrow('dddd') + '</span>' +
            '</div>' +
        '</li>' +
        '<li class="pick-due-date" data-type="next_monday">' +
            '<div class="flex-between">' +
                '<span>Next week</span>' +
                '<span class="text-info margin-left-24">' + Util.getNextMonday('dddd') + '</span>' +
            '</div>' +
        '</li>' +
        '<li class="pick-due-date">Pick a date</li>';

        var content =
        (is_merged_feedback ?
        '<div class="merged-tips">' +
            '<div class="text-info margin-bottom-12">This feedback has been merged into another feedback.</div>' +
            '<div class="flex-start">' +
                '<a href="#" class="primary font-weight-medium unmerge-feedback">Unmerge</a>' +
                '<i class="fa-solid fa-circle-small"></i>' +
                '<a href="#" class="primary font-weight-medium open-primary-feedback">View primary feedback</a>' +
            '</div>' +
        '</div>' :

        '<div class="info-grid-large">' +
            '<div class="info-title">Type</div>' +
            '<div class="info-value">' +
                '<div class="button-dropdown button-dropdown-full">' +
                    '<button type="button" class="dropdown-select">' + this.model.getFeedbackTypeName() + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-feedback-type">' +
                            '<li data-val="' + Constants.FEEDBACK_BUG             + '"' + (this.model.get('feedback_type') === Constants.FEEDBACK_BUG             ? ' class="selected"' : '') + '>Bug</li>' +
                            '<li data-val="' + Constants.FEEDBACK_FEATURE_REQUEST + '"' + (this.model.get('feedback_type') === Constants.FEEDBACK_FEATURE_REQUEST ? ' class="selected"' : '') + '>Idea</li>' +
                            '<li data-val="' + Constants.FEEDBACK_GENERAL         + '"' + (this.model.get('feedback_type') === Constants.FEEDBACK_GENERAL         ? ' class="selected"' : '') + '>General</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            (Cache.account.hasFeature('portal') && portal && this.model.get('feedback_type') === Constants.FEEDBACK_FEATURE_REQUEST
                ?
                '<div class="info-title">Portal Visibility</div>' +
                '<div class="info-value">' +
                    '<div class="button-dropdown button-dropdown-full">' +
                        '<button type="button" class="dropdown-select">' + (this.model.get('is_portal_approved') ? '<i class="fa-solid fa-eye text-small text-primary"></i> Yes' : '<i class="fa-solid fa-eye-slash text-small text-info"></i> No') + '</button>' +
                        '<div>' +
                            '<ul class="dropdown dropdown-select dropdown-feedback-approve">' +
                                '<li data-val="1"' + (this.model.get('is_portal_approved') ? ' class="selected"' : '') + '>Yes</li>' +
                                '<li data-val="0"' + (this.model.get('is_portal_approved') ? '' : ' class="selected"') + '>No</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                    (portal.isFeedbackVisible(this.model)
                    ? '<div class="margin-top-4"><a href="' + portal.getUrl() + '/idea/' + this.model.id + '" class="primary text-medium" target="portal">Open in portal <i class="fa-solid fa-square-arrow-up-right"></i></a></div>'
                    : '') +
                '</div>'
                : '')  +

            '<div class="info-title">Status</div>' +
            '<div class="info-value workflow-dropdown-group">' +
                '<div class="button-dropdown button-dropdown-full" data-append="true" data-trim="false" data-offset="' + (is_resolved ? '' : '32,0') + '" resolved="' + (is_resolved ? 1 : 0) + '">' +
                    '<button type="button" class="dropdown-select">' +
                        '<span class="workflow-option-colour" style="background-color:' + (selected_workflow ? selected_workflow.get('colour') : '') + ';"></span>' +
                        workflow_name +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-workflow">' + workflow_options + '</ul>' +
                    '</div>' +
                '</div>' +
                '<button type="button" class="tertiary small square resolve tooltip" data-title="' + resolve_title + '" data-position="down" data-offset="0,-10" resolved="' + (is_resolved ? 1 : 0) + '">' +
                    '<i class="fas fa-check-circle"></i>' +
                '</button>' +
            '</div>' +

            '<div class="info-title">Assignee</div>' +
            '<div class="info-value">' +
                '<div class="button-dropdown button-dropdown-full" data-append="true" data-trim="false">' +
                    '<button type="button" class="dropdown-select">' + (assigned_user ? '<img class="icon-img icon-img-round" src="' + assigned_user.getAvatar(24) + '">' + assigned_user.escape('name') : 'Unassigned') + '</button>' +
                    '<div>' +
                        (assignees.length > 10 ?
                        '<div class="dropdown-search">' +
                            '<input type="text" class="solid compact" placeholder="Search by user name">' +
                        '</div>' : '') +
                        '<ul class="dropdown dropdown-select dropdown-assignee">' +
                            '<li data-id="0" ' + (assigned_user_id === 0 ? ' class="selected"' : '') + '>' +
                                '<img class="user-img" src="/image/profile.png">' +
                                'Unassigned' +
                            '</li>' +
                            assignees.map((user) => {
                                return '' +
                                '<li data-id="' + user.id + '" ' + (user.id === assigned_user_id ? ' class="selected"' : '') + '>' +
                                    '<img class="user-img" src="' + user.getAvatar(24) + '">' +
                                    user.escape('name') +
                                '</li>';
                            }).join('') +
                        '</ul>' +
                        (Cache.app.isAdmin() ?
                        '<div>' +
                            '<button type="button" class="user-invite text-primary-small small"><i class="fa-solid fa-envelope"></i>Invite team members via email</button>' +
                        '</div>' : '') +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<div class="info-title">Priority</div>' +
            '<div class="info-value">' +
                '<div class="button-dropdown button-dropdown-full">' +
                    '<button type="button" class="dropdown-select">' +
                        '<span class="priority-flag-icon priority-text-' + this.model.get('priority').toLowerCase() + '"><i class="fa-solid fa-flag"></i></span>' +
                        '<span>' + Util.cap(this.model.get('priority')) + '</span>' +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-priority">' +
                        '<li' + (this.model.get('priority') === 'urgent'  ? ' class="selected"' : '') + ' data-priority="urgent"><span class="priority-flag-icon priority-text-urgent"><i class="fa-solid fa-flag"></i></span>Urgent</li>' +
                        '<li' + (this.model.get('priority') === 'high'    ? ' class="selected"' : '') + ' data-priority="high"><span class="priority-flag-icon priority-text-high"><i class="fa-solid fa-flag"></i></span>High</li>' +
                        '<li' + (this.model.get('priority') === 'neutral' ? ' class="selected"' : '') + ' data-priority="neutral"><span class="priority-flag-icon priority-text-neutral"><i class="fa-solid fa-flag"></i></span>Neutral</li>' +
                        '<li' + (this.model.get('priority') === 'low'     ? ' class="selected"' : '') + ' data-priority="low"><span class="priority-flag-icon priority-text-low"><i class="fa-solid fa-flag"></i></span>Low</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<div class="info-title">Category</div>' +
            '<div class="info-value">' +
                '<div class="button-dropdown button-dropdown-full" data-append="true" data-trim="false">' +
                    '<button type="button" class="dropdown-select dropdown-select-multiple">' +
                        (selected_categories.length > 0 ?
                        selected_categories.map((category) => {
                            return '' +
                            '<span class="badge-primary-invert badge-small font-weight-medium">' +
                                '<span>' + Util.htmlEntities(category) + '</span>' +
                            '</span>';
                        }).join('')

                        :

                        '<span class="placeholder-text">Select...</span>') +
                    '</button>' +
                    '<div>' +
                        (categories.length > 10 ?
                        '<div class="dropdown-search">' +
                            '<input type="text" class="solid compact" placeholder="Search">' +
                        '</div>' : '') +
                        '<ul class="dropdown dropdown-select dropdown-feedback-category">' +
                            categories.map((model) => {
                                return '<li class="' + (selected_categories.indexOf(model.escape('name')) !== -1 ? 'selected' : '') + ' title="' + model.escape('name') + '">' + model.escape('name') + '</li>';
                            }).join('') +
                        '</ul>' +
                        (Cache.app.isAdmin() ?
                        '<div>' +
                            '<button type="button" class="manage-categories text-primary-small small"><i class="fa-solid fa-cog"></i>Manage Categories</button>' +
                        '</div>' : '') +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<div class="info-title">Due date</div>' +
            '<div class="info-value position-relative">' +
                '<div class="button-dropdown button-dropdown-full" data-append="true" data-trim="false">' +
                    '<button type="button" class="dropdown-select dropdown-select-multiple feedback-due-date-text tooltip" data-title="' + due_date_tooltip + '">' +
                        (due_date_text || '<span class="placeholder-text">Select...</span>') +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown">' +
                        due_date_options +
                        '</ul>' +
                    '</div>' +
                '</div>' +
                '<input type="date" name="feedback_due_date" class="hidden-date-picker">' +
            '</div>' +

            (this.inbox_mode ? '' :
            '<div class="info-title">Integrations</div>' +
            '<div class="info-value region-integrations flex-start"></div>') +
        '</div>');

        this.$el.html(content);

        if (!this.inbox_mode) {
            if (this.views.integrations instanceof View_Integrations) {
                this.views.integrations.remove();
            }

            this.views.integrations = new View_Integrations({
                model: this.model,
                show_empty: true
            });
            this.views.integrations.render().$el.appendTo(this.$('.region-integrations'));
        }

        Form.setData(this.$el, {
            feedback_due_date: this.model.get('due_date') ? Util.moment(due_date, 'yyyy-MM-dd', false, false) : ''
        });

        return this;
    }
});